import { useCallback, useState } from "react";
import { exportOutboxNotifications } from "../api/outboxNotifications.api";
import type {
  OutboxNotificationExport,
  OutboxNotificationFilters,
} from "../types/outboxNotifications.types";

export function useExportOutboxNotifications() {
  const [isExporting, setIsExporting] = useState(false);

  const exportReport = useCallback(async (filters: OutboxNotificationFilters): Promise<OutboxNotificationExport | undefined> => {
    if (isExporting) return undefined;

    setIsExporting(true);
    try {
      return await exportOutboxNotifications(filters);
    } finally {
      setIsExporting(false);
    }
  }, [isExporting]);

  return { exportReport, isExporting };
}
